var _module_exports = "<div ng-if=\"!hasUpdateDetectorCapability || !hasWritePermission\">\n  {{ getDisableTooltipText() }}\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/tooltips/detectorSaveTooltip.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;